import Cookies from "js-cookie";

import { GenerateEmailPayload } from "../api-hooks/brie/useGenerateEmail";
import { CustomPromptPayload } from "../api-hooks/brie/useCustomPrompt";
import { MappedDomain } from "../api-hooks/brie/useDomainMapper";
import TenantAPI from "./TenantAPI";
import API from "./API";

export default class AIToolsAPI {
  // Brie AI Tools
  static async brieQuestionGenerator(text: string) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/brie/generateQuestion",
      { text },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async brieProcessRequest(payload: any) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/brie/processRequest",
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // ------------------------------------------ Domain Mapper Endpoints ------------------------------------------------

  static async brieDomainMapper({
    selectedCompanies,
    maximumContacts,
    excludeOptions,
  }: {
    selectedCompanies: string[];
    maximumContacts?: number;
    excludeOptions?: string[];
  }) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/brie/domainMapper/map",
      { selectedCompanies, maximumContacts, excludeOptions },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async brieDomainMapperApply({
    selectedMappedDomains,
  }: {
    selectedMappedDomains: MappedDomain[];
  }) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/brie/domainMapper/apply",
      { selectedMappedDomains },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // ------------------------------------------ AskYourPDF Endpoints ------------------------------------------------

  static async askYourPDFUpload(file: any) {
    const bodyFormData = new FormData();
    bodyFormData.append("file", file);

    return API._bearerRequest(
      "post",
      "/tenant/ai/brie/askYourPDF/upload",
      bodyFormData,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async askYourPDFGetData(query: string, dbName: string) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/brie/askYourPDF/get_data",
      { query, dbName },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async askYourPDFDelete(fileName: string, dbName: string) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/brie/askYourPDF/delete_file",
      { fileName, dbName },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // Open AI Tools
  static async sentimentAnalysis(text: string) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/open-ai/sentimentAnalysis",
      { text },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async summarizeText(
    text: string,
    wordCount: number,
    language?: string
  ) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/open-ai/summarize",
      { text: text, wordCount: wordCount, language: language },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async namedEntityRecognition(text: string) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/open-ai/namedEntityRecognition",
      { text },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async generateEmail(payload: GenerateEmailPayload) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/open-ai/generateEmail",
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async generateText(payload: CustomPromptPayload) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/open-ai/generateText",
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async questionGenerator(
    text: string,
    questionCount: number,
    questionType: string
  ) {
    return API._bearerRequest(
      "post",
      "/tenant/ai/open-ai/generateQuestion",
      { text, questionCount, questionType },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async translatePdf(fileUrl: string, language: string) {
    const finalToken =
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`) ||
      "undefined";

    return fetch(
      `${(window as any).GC_API_URL}/tenant/ai/brie/translate/${language}`,
      {
        method: "POST",
        body: JSON.stringify({ FileURL: fileUrl }),
        headers: {
          Authorization: "Bearer " + finalToken,
          "Content-Type": "application/json",
          "app-id": "GrowthCloud",
        },
        credentials: "include",
      }
    )
      .then(async (response) => {
        if (!response.ok) {
          const res = await response.json();

          throw res;
        }
        return response.blob();
      })
      .then((pdfBlob) => {
        let blobFile = new Blob([pdfBlob], { type: "application/pdf" });
        let blobUrl = URL.createObjectURL(blobFile);

        return blobUrl;
      });
  }
}
